// extracted by mini-css-extract-plugin
export default {"card":"ZY-z","carouselContainer":"_Y-z","carouselContent":"aZ-z"};